import { autoinject, bindable, bindingMode } from "aurelia-framework";


@autoinject
export class RememberMe {
  @bindable({ defaultBindingMode: bindingMode.toView })
  public email: string;
  @bindable({ defaultBindingMode: bindingMode.twoWay })
  public rememberMe: boolean;
}
